"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("./Icon.style"));
var _excluded = ["className", "onClick", "icon", "size", "id", "disabled", "onTouchStart", "onTouchEnd", "onMouseDown", "onMouseUp"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Icon = function Icon(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    icon = _ref.icon,
    size = _ref.size,
    id = _ref.id,
    disabled = _ref.disabled,
    onTouchStart = _ref.onTouchStart,
    onTouchEnd = _ref.onTouchEnd,
    onMouseDown = _ref.onMouseDown,
    onMouseUp = _ref.onMouseUp,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var properties = typeof onClick === 'function' && !disabled ? {
    onClick: onClick,
    onKeyDown: onClick,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    role: 'button',
    tabIndex: '0'
  } : {};
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    className: "icon-".concat(icon, " ").concat(className),
    size: size,
    id: id,
    disabled: disabled
  }, properties, otherProps));
};
Icon.defaultProps = {
  className: '',
  icon: '',
  size: 12,
  id: '',
  onClick: null,
  onTouchStart: null,
  onTouchEnd: null,
  onMouseDown: null,
  onMouseUp: null,
  disabled: false
};
Icon.propTypes = {
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
  disabled: _propTypes["default"].bool,
  icon: _propTypes["default"].string,
  size: _propTypes["default"].number,
  id: _propTypes["default"].string,
  onTouchStart: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func
};
Icon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Icon",
  "props": {
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "icon": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "size": {
      "defaultValue": {
        "value": "12",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onClick": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "func"
        }, {
          "name": "bool"
        }]
      },
      "required": false
    },
    "onTouchStart": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onTouchEnd": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onMouseDown": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onMouseUp": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(Icon);
exports["default"] = _default;